import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError, finalize, map} from 'rxjs/operators';

import {
  DIALECT_API_URL,
  DIALECT_DETAIL_API_URL, DIALECT_LINKS_API_URL,
  PAGE,
} from '../../defines/protocol';
import {SearchParam} from '../../defines/client.const';
import {NormalizeSearchKeyword} from '../../defines/client.func';
import {ListLoader} from '../../interfaces/list-loader';
import {Dialect, SimpleDialect} from '../../models/dialect.model';
import {ApiService} from '../api/api.service';


@Injectable({
  providedIn: 'root'
})
export class DialectService implements ListLoader<SimpleDialect> {
  protected urlApi = DIALECT_API_URL;

  protected totalCount: number | null = null;
  protected listDialect: Array<SimpleDialect> | null = null;
  private mapDialect: Map<string, SimpleDialect> | null = null;
  private nextUrl: string | null = null;
  private load$: Observable<boolean> | null = null;
  private loadDetail$: Observable<Dialect> | null = null;
  private loadLink$: Observable<Array<SimpleDialect>> | null = null;

  constructor(
    protected api: ApiService,
  ) { }


  /******************************************************************************
   * ListLoader<Word> 구현부
   *****************************************************************************/
  public getList(): Array<SimpleDialect> | null {
    return this.listDialect;
  }
  public getCurCount(): number | null {
    return this.listDialect?.length ?? null;
  }
  public getTotalCount(): number | null {
    return this.totalCount;
  }
  public IsComplete(): boolean {
    return this.totalCount === 0 ||
      (this.totalCount !== null && this.listDialect?.length === this.totalCount);
  }
  public IsLoading(): boolean {
    return this.load$ !== null;
  }
  public getById(id: string): SimpleDialect | null {
    return this.mapDialect?.get(id) ?? null;
  }

  public ResetList(param?: SearchParam): void {
    this.nextUrl = null;
    this.listDialect = null;
    this.mapDialect = null;
    this.totalCount = null;

    if (param) {
      if ('index' in param) {
        this.nextUrl = this.urlApi + '?index=' + param.index;
      }
      else if ('keyword' in param) {
        const keyword = NormalizeSearchKeyword(param.keyword);
        if (keyword) {
          this.nextUrl = this.urlApi + '?search=' + keyword;
        }
      }

      if ('region2' in param) {
        this.nextUrl = this.nextUrl ?
          this.nextUrl + '&region=' + param.region2 :
          this.urlApi + '?region=' + param.region2;
      }

      if ('start' in param) {
        this.nextUrl = this.nextUrl ?
          this.nextUrl + '&start=' + param.start :
          this.urlApi + '?start=' + param.start;
      }
    }

    if (!this.nextUrl) {
      this.nextUrl = this.urlApi;
    }
  }

  public GetNextList(): Observable<boolean> {
    if (this.nextUrl === null) {
      return throwError({error: 'No more pages in DialectList'});
    }

    if (this.load$) {
      return this.load$;
    }

    if (this.nextUrl === null) {
      throw new Error('DialectService::GetNextList() nextUrl is null');
    }
    return this.load$ = this.api.Get(this.nextUrl).pipe(
      catchError(err => {
        if ('status' in err && err.status === 404) {
          this.totalCount = 0;
        }
        throw err;
      }),
      finalize(() => {
        this.load$ = null;
      } ),
      map((data: PAGE) => {
        console.log('DialectService::GetNextList() data =', data);

        let first = false;
        if (this.totalCount === null) {
          this.totalCount = data.count;
          this.listDialect = new Array<SimpleDialect>();
          this.mapDialect = new Map<string, SimpleDialect>();
          first = true;
        }
        else if (this.totalCount !== data.count) {
          console.error('[error]' + this.urlApi, data );
        }

        data.results.forEach(value => {
          if (this.listDialect === null) {
            throw new Error("DialectService::GetNextList() listDialect is null");
          }
          if (this.mapDialect === null) {
            throw new Error("DialectService::GetNextList() mapDialect is null");
          }

          const dialect = new SimpleDialect(value);
          this.listDialect.push(dialect);
          this.mapDialect.set(dialect.id, dialect);
        });

        this.nextUrl = data.next;

        return first;
      })
    );
  }


  /******************************************************************************
   * 상세 사투리 정보 획득
   * 위쪽의 목록에는 간섭이 없도록 처리하는 것이 좋다.
   * TODO: 로딩중인 것을 처리. (예외상황 처리 추가해야 함)
   *****************************************************************************/
  // tslint:disable-next-line:variable-name
  public GetDetail(dialect_id: string): Observable<Dialect> {
    const url = DIALECT_DETAIL_API_URL + dialect_id + '/';
    console.log('DialectService::GetDetail() url =', url);

    return this.loadDetail$ = this.api.Get(url).pipe(
      finalize(() => this.loadDetail$ = null),
      map(value => {
        const out = new Dialect(value);
        console.log('DialectService::GetDetail data = ', value, out);
        return out;
      })
    );
  }

  /******************************************************************************
   * 링크용 단순 사투리 정보 획득
   * 위쪽의 목록에는 간섭이 없도록 처리하는 것이 좋다.
   * TODO: 로딩중인 것을 처리. (예외상황 처리 추가해야 함)
   *****************************************************************************/
  // tslint:disable-next-line:variable-name
  public GetLinkInfo(dialect_id: string): Observable<Array<SimpleDialect>> {
    const url = DIALECT_LINKS_API_URL + dialect_id + '/';
    console.log('DialectService::GetLinkInfo() url =', url);

    return this.loadLink$ = this.api.Get(url).pipe(
      finalize(() => this.loadLink$ = null),
      map(value => {
        const out= new Array<SimpleDialect>();
        value.forEach((v: any) => out.push(new SimpleDialect(v)));
        console.log('DialectService::GetLinkInfo data = ', value, out);
        return out;
      }),
    );
  }
}
